export default __webpack_public_path__ + "static/fan_b.af9ede1b71c7721bedf5d98e77a8566f.png";